/**
 * Deterministic reviewer color assignment.
 * 8 high-contrast colors, cycles if more than 8 users.
 */

const REVIEWER_COLORS = [
  '#2d8cf0', // blue
  '#c43c2d', // red
  '#4caf50', // green
  '#f5a623', // amber
  '#9c27b0', // purple
  '#00bcd4', // cyan
  '#ff6f00', // deep orange
  '#e91e90', // pink
] as const;

/** Simple string hash (djb2). Returns a non-negative integer. */
function hashString(str: string): number {
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) + hash + str.charCodeAt(i)) >>> 0;
  }
  return hash;
}

/**
 * Get a deterministic color for a reviewer name.
 * Same name always maps to the same color. Cycles after 8.
 */
export function getReviewerColor(name: string): string {
  const normalized = (name || 'reviewer').trim().toLowerCase();
  return REVIEWER_COLORS[hashString(normalized) % REVIEWER_COLORS.length];
}
